import { fetchData } from '../../utils';
import { ApiResponse } from '../../types';
import {
  MetaTouchpointSetup,
  TiktokTouchpointSetup,
  YouTubeTouchpointSetup,
} from '../../../pages/calculator/MediaPlanning/components/Touchpoints/interfaces';
import { CAMPAIGN, CAMPAIGNv3 } from './mediaPlanning';

export const getYouTubeConfig = async (
  division: string,
  brand: string,
  category: string,
  countryISO: string,
  campaignTargetGroup: string,
  campaignScenario: string,
  touchpointTargetGroup?: string,
  isTVIncluded?: boolean | null
) => {
  return fetchData<ApiResponse<YouTubeTouchpointSetup>>(
    `/${CAMPAIGNv3}/touchpoints/youtube-setup`,
    {
      params: {
        division,
        brand,
        category,
        countryISO,
        campaignTargetGroup,
        campaignScenario,
        touchpointName: 'YOUTUBE',
        ...(touchpointTargetGroup && { touchpointTargetGroup }),
        ...(isTVIncluded != null && { isTVIncluded }),
      },
    }
  );
};

export const getMetaConfig = async (
  division: string,
  brand: string,
  category: string,
  countryISO: string,
  targetGroup: string,
  campaignScenario: string,
  touchpointTargetGroup?: string | null,
  touchpointStartDate?: string | null,
  touchpointLength?: string | null,
  isTVIncluded?: boolean | null
) => {
  return fetchData<ApiResponse<MetaTouchpointSetup>>(
    `/${CAMPAIGN}/touchpoints/meta-setup`,
    {
      params: {
        division,
        brand,
        category,
        countryISO,
        targetGroup,
        campaignScenario,
        touchpointName: 'META',
        touchpointTargetGroup,
        touchpointStartDate,
        touchpointLength,
        ...(isTVIncluded != null && { isTVIncluded }),
      },
    }
  );
};

export const getTiktokConfig = async (
  division: string,
  brand: string,
  category: string,
  countryISO: string,
  campaignTargetGroup: string,
  campaignScenario: string,
  touchpointTargetGroup?: string | null,
  isTVIncluded?: boolean | null
) => {
  return fetchData<ApiResponse<TiktokTouchpointSetup>>(
    `/${CAMPAIGN}/touchpoints/tiktok-setup`,
    {
      params: {
        division,
        brand,
        category,
        countryISO,
        campaignTargetGroup,
        campaignScenario,
        touchpointName: 'TIKTOK',
        touchpointTargetGroup,
        ...(isTVIncluded != null && { isTVIncluded }),
      },
    }
  );
};
